import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class Formgroup {
	static classname = 'formgroup';

	constructor($formgroup) {
		this.$formgroup = $formgroup;
		this.init();
		this.bindEvents();
	}

	init() {
		if (this.$formgroup.find('.formgroup__input').val()) {
			this.$formgroup.addClass('formgroup--hasvalue');
		}
	}

	bindEvents() {
		const $input = this.$formgroup.find('.formgroup__input');

		$input.on('focus', () => {
			this.$formgroup.addClass('formgroup--focused');
		}).on('blur', () => {
			this.$formgroup.removeClass('formgroup--focused');
		});

		$input.on('input', () => {
			this.$formgroup.removeClass('formgroup--error');
			this.$formgroup.find('.formgroup__error').remove();
			if ($input.val()) {
				this.$formgroup.addClass('formgroup--hasvalue');
			} else {
				this.$formgroup.removeClass('formgroup--hasvalue');
			}
		});
	}
}
